import * as $ from "jquery";
import axios from "axios";
import {nanoid} from "nanoid";
import {
    emptyForm,
    enableFormBack,
    handleApiForm,
} from "../../../forms";
import {closeModal, openModal} from "../../../utilities";
import {toastAlert} from "../../../toastAlert";
import {confirmModal} from "../../../confirmModal";
import {EpHuntingDevicesLayer} from "../../../map/layers/group-hunting-devices";

export const groupHuntingLocationDevices = (epMap) => {
    // add/edit location points form
    const locationDeviceForm = $('#addHuntingDevice');
    const form = $('body').find('#addHuntingLocation, #editHuntingLocation');

    const container = $('[data-app-map_interaction_container="devices"]')
    const table = container.find('table').DataTable({ paging: false, info: false,  dom: '<"d-flex justify-content-between"lf>t',})

    const container2 = $('[data-app-map_interaction_container="hunters"]')
    const table2 = container2.find('table').DataTable({ paging: false, info: false,  dom: '<"d-flex justify-content-between"lf>t',});

    // locations layer
    let locationDeviceLayer = new EpHuntingDevicesLayer(epMap.map)
    epMap.addCustomLayer(locationDeviceLayer);
    epMap.hideLabelsIfNecessary(locationDeviceLayer);
    epMap.locationDevicesLayer = locationDeviceLayer;

    let hunterPointsEpLayer = epMap.hunterPointsEpLayer;

    $('[data-app_device_id]').each(function() {
        let id = $(this).data('app_device_id');

        let feature = locationDeviceLayer.addFeature([
            parseFloat(String($(`[name="devices[${id}][longitude]"]`).val())),
            parseFloat(String($(`[name="devices[${id}][latitude]"]`).val()))
        ]);

        feature.set('id', id);
        feature.set('name', $(`[name="devices[${id}][name]"]`).val());
        feature.set('type', 'devices');
        feature.set('device_type_id', $(`[name="devices[${id}][device_type_id]"]`).val());
    })

    $('[data-app-map_interaction_button="devices"]').click(function() {
        const modal = $('#deviceModal');

        modal.find('.modal-title').text('Dodawanie urządzenia');

        modal.find('[name="id"]').val('')
        modal.find('[name="name"]').val('')
        modal.find('[name="device_type_id"]').val('')
        modal.find('[name="latitude"]').val('')
        modal.find('[name="longitude"]').val('')
        modal.find('[name="is_new"]').val(true)

        const firstOptionValue = modal.find('[name="device_type_id"] option:first').val();
        modal.find('[name="device_type_id"]').val(firstOptionValue);

        openModal('#deviceModal');
    })

    table.on('click', '.btnEditDevice', function() {
        const modal = $('#deviceModal');

        modal.find('.modal-title').text('Edycja urządzenia');

        const id = $(this).attr('data-id');

        const name = $(`[name="devices[${id}][name]"]`).val();
        const latitude = $(`[name="devices[${id}][latitude]"]`).val();
        const longitude = $(`[name="devices[${id}][longitude]"]`).val();
        const type = $(`[name="devices[${id}][device_type_id]"]`).val();
        const original_id = $(`[name="devices[${id}][original_id]"]`).val();
        //const isNew = $(`[name="points[${id}][is_new]"]`).val();

        modal.find('[name="id"]').val(id)
        modal.find('[name="name"]').val(name)
        modal.find('[name="latitude"]').val(latitude)
        modal.find('[name="longitude"]').val(longitude)
        modal.find('[name="device_type_id"]').val(type)
        modal.find('[name="is_new"]').val(false)
        modal.find('[name="original_id"]').val(original_id)

        openModal('#deviceModal');
    })


    table.on('click', '.btnDeleteDevice', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć urządzenie?', {color: 'danger'});
        if (!confirm) return;

        const id = $(this).attr('data-id');


        try {
            const response = await axios.post(window._DELETE_DEVICE_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }


            let feature = locationDeviceLayer
                .getSource()
                .getFeatures()
                .find(feature => feature.get('id') == id);


            if(feature) {
                locationDeviceLayer
                    .getSource()
                    .removeFeature(feature);
            }
            else{
                let feature = locationDeviceLayer
                    .getSource()
                    .getFeatures()
                    .find(feature => feature.id_ == id);

                if(feature) {
                    locationDeviceLayer
                        .getSource()
                        .removeFeature(feature);
                }
            }

            $(`[name="devices[${id}][name]"]`).remove();
            $(`[name="devices[${id}][latitude]"]`).remove();
            $(`[name="devices[${id}][longitude]"]`).remove();
            $(`[name="devices[${id}][is_new]"]`).remove();


            let spot_feature = hunterPointsEpLayer
                .getSource()
                .getFeatures()
                .find(spot_feature => spot_feature.get('device_id') == id);


            if(spot_feature){
                hunterPointsEpLayer
                    .getSource()
                    .removeFeature(spot_feature);


                let hunterContaner = $('[data-app-map_interaction_container="hunters"]')
                let hunterTable = hunterContaner.find('table').DataTable()
                const hunterRow = hunterTable.$(`tr[data-id="${spot_feature.get('point_id')}"]`);
                hunterTable.api().row(hunterRow).remove().draw();
            }

            const row = table.$(`tr[data-id="${id}"]`);
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto urządzenie');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia urządzenia', {type: 'danger'})
        }
    })

    let tempId = nanoid();

    locationDeviceForm.submit(function(e) {
        e.preventDefault();

        let formData = new FormData(this);

        if(formData.get('id').length > 0) {
            // editing..
            tempId = formData.get('id');

            let feature = locationDeviceLayer
                .getSource()
                .getFeatures()
                .find(feature => String(feature.get('id')) === String(tempId));

            locationDeviceLayer
                .getSource()
                .removeFeature(feature)

            if(feature) {

                let spot_feature = hunterPointsEpLayer
                    .getSource()
                    .getFeatures()
                    .find(spot_feature => spot_feature.get('device_id') == tempId);


                if (spot_feature) {
                    spot_feature.set('name', formData.get('name'));
                    table2.$(`tr[data-id="${spot_feature.get('point_id')}"]`).find('.hunter-name').text(formData.get('name'))
                    table2.$(`tr[data-id="${spot_feature.get('id')}"]`).find('.hunter-name').text(formData.get('name'))
                }
            }


            $(`[name="devices[${tempId}][name]"]`).val(formData.get('name'))
            $(`[name="devices[${tempId}][latitude]"]`).val(formData.get('latitude'))
            $(`[name="devices[${tempId}][longitude]"]`).val(formData.get('longitude'))
            $(`[name="devices[${tempId}][device_type_id]"]`).val(formData.get('device_type_id'))
            $(`[name="devices[${tempId}][sector_name]"]`).val(formData.get('sector_name'))
            $(`[name="devices[${tempId}][original_id]"]`).val(formData.get('original_id'))

            table.$(`tr[data-id="${tempId}"]`).find('.device-name').text(formData.get('name'))
        } else {

            form.append(`<input type="hidden" name="devices[${tempId}][name]" value="${formData.get('name')}" />`)
            form.append(`<input type="hidden" name="devices[${tempId}][device_type_id]" value="${formData.get('device_type_id')}" />`)
            form.append(`<input type="hidden" name="devices[${tempId}][latitude]" value="${formData.get('latitude')}" />`)
            form.append(`<input type="hidden" name="devices[${tempId}][longitude]" value="${formData.get('longitude')}" />`)
            form.append(`<input type="hidden" name="devices[${tempId}][original_id]" value="${formData.get('original_id')}" />`)
            form.append(`<input type="hidden" name="devices[${tempId}][sector_name]" value="${formData.get('sector_name')}" />`)


            // form.append(`<input type="hidden" name="devices[${id}][is_new]" value="true" />`)

            let row = $(`
                <tr data-id="${tempId}">
                    <td class="device-name">${formData.get('name')}</td>
                    <td class="device-sector">${formData.get('sector_name')}</td>
                    <td>
                      <button data-id="${tempId}" type="button" class="btn btn-sm btn-primary btnAddHuntersOnDevices">
                              Użyj
                        </button>
                        <button data-id="${tempId}" type="button" class="btn btn-sm btn-primary btnEditDevice">
                            Edytuj
                        </button>
                        <button data-id="${tempId}" type="button" class="btn btn-sm btn-danger btnDeleteDevice">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row);
            table.api().draw();
        }

        let feature = locationDeviceLayer.addFeature([
            parseFloat(String(formData.get('longitude'))),
            parseFloat(String(formData.get('latitude')))
        ]);

        feature.set('id', tempId);
        feature.set('name', formData.get('name'));
        feature.set('type', 'devices');
        feature.set('device_type_id', formData.get('device_type_id'));

        enableFormBack(this);
        closeModal('#deviceModal');
    })


    handleApiForm('#addHuntingDevice', ({response, form}) => {
        if (response.data.code === 200) {

            let realId = response.data.device.id;

            // Find the row with the temporary ID and update it
            let newRow = table.$(`tr[data-id="${tempId}"]`);
            newRow.attr('data-id', realId);
            newRow.find('.btnAddHuntersOnDevices').attr('data-id', realId);
            newRow.find('.btnEditDevice').attr('data-id', realId);
            newRow.find('.btnDeleteDevice').attr('data-id', realId);

            // Update the hidden inputs with the real device ID
            $(`[name="devices[${tempId}][name]"]`).attr('name', `devices[${realId}][name]`);
            $(`[name="devices[${tempId}][latitude]"]`).attr('name', `devices[${realId}][latitude]`);
            $(`[name="devices[${tempId}][longitude]"]`).attr('name', `devices[${realId}][longitude]`);
            $(`[name="devices[${tempId}][device_type_id]"]`).attr('name', `devices[${realId}][device_type_id]`);
            $(`[name="devices[${tempId}][sector_name]"]`).attr('name', `devices[${realId}][sector_name]`);

            // Optional: Update the name text if needed
            newRow.find('.device-name').text(response.data.device.name);
            newRow.find('.device-sector').text(response.data.device.sector_name);

            let feature = locationDeviceLayer
                .getSource()
                .getFeatures()
                .find(feature => feature.get('id') == tempId);


            if(feature) {
                feature.set('id', realId);
            }
            else{
                let feature = locationDeviceLayer
                    .getSource()
                    .getFeatures()
                    .find(feature => feature.id_ == tempId);

                if(feature) {
                    feature.set('id', realId);
                }
            }

            if(feature) {

                let spot_feature = hunterPointsEpLayer
                    .getSource()
                    .getFeatures()
                    .find(spot_feature => spot_feature.get('device_id') == tempId);


                if (spot_feature) {
                    spot_feature.set('device_id', realId);
                }
            }

            closeModal('#deviceModal');
            emptyForm(form);
            toastAlert('Pomyślnie dodano urządzenie');
        }
    })


    table.on('click', '.btnAddHuntersOnDevices', async function() {

        const uid = $(this).attr('data-id');

        try {

            const response = await axios.post(window._ADD_HUNTERS_ON_DEVICES.replace('REPLACE_ID', uid));

            if (response.data.code !== 200) {
                throw new Error();
            }

            response.data.spots.forEach(spot => {
                let id = spot.id;

                $('body').append(`
                    <input type="hidden" name="hunters[${id}][name]" value="${spot.name}" />
                    <input type="hidden" name="hunters[${id}][latitude]" value="${spot.latitude}" />
                    <input type="hidden" name="hunters[${id}][longitude]" value="${spot.longitude}" />
                    <input type="hidden" name="hunters[${id}][type]" value="${spot.type}" />
                    <input type="hidden" name="hunters[${id}][device_id]" value="${spot.device_id}" />
                     <input type="hidden" name="hunters[${id}][id]" value="${id}" />
                `);

                let row = $(`
                <tr data-id="${spot.id}">
                    <td class="hunter-name">${spot.name}</td>
                    <td>
                        <button data-id="${spot.id}" type="button" class="btn btn-sm btn-primary btnEditHunterPoint">Edytuj</button>
                        <button data-id="${spot.id}" type="button" class="btn btn-sm btn-danger btnDeleteHunterPoint">Usuń</button>
                    </td>
                </tr>
            `);

                table2.api().rows.add(row);
                table2.api().draw();

                let feature = hunterPointsEpLayer.addFeature([
                    parseFloat(String(spot.longitude)),
                    parseFloat(String(spot.latitude))
                ]);

                feature.set('id', spot.id);
                feature.set('name', spot.name);
                feature.set('device_type', spot.type ? spot.type : 1);
                feature.set('device_id', spot.device_id);

            });

        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodania stanowisk myśliwych', {type: 'danger'});
        }
    });

}